import Axios from "../../../../../api/axios/Axios";

const encode = (value) => encodeURIComponent(String(value ?? "").trim());

export const getUserGroupAlbums = (groupTag, limit = 12, offset = 0) =>
  Axios.get(`/api/groups/${encode(groupTag)}/albums`, {
    params: { limit, offset },
  });

export const getUserGroupAlbum = (groupTag, albumTag, limit = 50, offset = 0) =>
  Axios.get(`/api/groups/${encode(groupTag)}/albums/${encode(albumTag)}`, {
    params: { limit, offset },
  });
